const palette = {
  whiteLight: '#FFFFFF',
  whiteDark: '#EEEEEE',
  white: '#F9F9F9',
  blue: '#0F52BA',
  grayLight: '#BFBFBF',
  gray: '#373737',
  grayDark: '#2C2C2C',
  black: '#000000',
};

export default palette;